// extracted by mini-css-extract-plugin
module.exports = {"container":"_hOn-qn9i","footerText":"_usnS0hMy"};